import React from 'react';
import SwitchlLanguage from './SwitchlLanguage';
const Header = ({ handleLngChange, descriptions }) => {

    return (


        // <!-- About-->
        <section className="resume-section" id="about">
            <div className="resume-section-content">
                <h1 className="mb-0">
                    Nizar
                    <span className="text-primary">Ben Younes</span>
                    <SwitchlLanguage onLngChange={handleLngChange} />

                </h1>

                <div className="subheading mb-5">
                    1 ere Adress: Wed zebib Djerba , 2 eme Adress : Ben Arous tunis · (+216) 29 372 408·
                    <a href="ben.younes.nizar@gmail.com">ben.younes.nizar@gmail.com</a>
                </div>
                <p className="lead mb-5">{descriptions}</p>
                <div className="social-icons">
                    <a className="social-icon" href="https://www.linkedin.com/in/nizar-ben-younes-803413111/"><i
                        className="fab fa-linkedin-in"></i></a>
                    <a className="social-icon" href="https://gitlab.com/ben.younes.nizar"><i className="fab fa-gitlab"></i></a>
                    <a className="social-icon" href="#!"><i className="fab fa-twitter"></i></a>
                    <a className="social-icon" href="#!"><i className="fab fa-facebook-f"></i></a>
                </div>
            </div>
        </section>

    );
};

export default Header;